import { FC, ReactNode } from 'react'
import { Box, BoxProps } from '@mui/material'
import { PRIMARY_COLORS_VARIANTS } from '@/utils/constants/colors'

interface HighlightedBoxElementProps {
  children: ReactNode
  boxProps?: BoxProps
}

export const HighlightedBoxElement: FC<HighlightedBoxElementProps> = ({ children, boxProps }) => {
  return (
    <Box
      bgcolor={PRIMARY_COLORS_VARIANTS[200]}
      border={`1px solid ${PRIMARY_COLORS_VARIANTS[300]}`}
      borderRadius="1rem"
      px={2}
      py={1.25}
      {...boxProps}
    >
      {children}
    </Box>
  )
}
